import deepMerge from 'deepmerge'
import React from 'react'
import ReactDOM from 'react-dom'
import { Form, Modal } from 'ui'

const createPromiseDefer = () => {
  const defer = {}
  defer.promise = new Promise((resolve, reject) => Object.assign(defer, { resolve, reject }))
  return defer
}

const buildModal = (buttons, content) => {
  buttons = deepMerge({ cancel: { label: 'Abbrechen' }, ok: { label: 'Ok' } }, buttons)
  content = React.Children.map(content, child => {
    return typeof child === 'string' ? <div dangerouslySetInnerHTML={{ __html: child }}></div> : child
  })

  const { promise, resolve } = createPromiseDefer()
  const holder = document.createElement('div')

  const removeModal = () => {
    ReactDOM.unmountComponentAtNode(holder)
    holder.remove()
  }

  const onCloseHandler = () => {
    resolve({ confirmed: false })
    removeModal()
  }

  const onSubmitHandler = (e, { data }) => {
    resolve({ confirmed: true, ...data })
    removeModal()
    return false
  }
  return { buttons, content, promise, holder, onCloseHandler, onSubmitHandler }
}

export const showModal = ({ title, content, buttons = {}, size = 'sm' }) => {
  const modal = buildModal(buttons, content)
  buttons = modal.buttons
  content = modal.content
  const promise = modal.promise
  const holder = modal.holder
  const onCloseHandler = modal.onCloseHandler
  const onSubmitHandler = modal.onSubmitHandler

  ReactDOM.render(
    <Modal size={size} title={title} hasCloseButton={!!title} open onClose={onCloseHandler}>
      <Form method="POST" onSubmit={onSubmitHandler} noAction>
        <Modal.Body>{content}</Modal.Body>
        <Modal.Footer>
          {buttons.cancel ? (
            <Form.Button data-modal-close className="me-1" type="button" text={buttons.cancel.label} secondary />
          ) : null}
          {buttons.ok ? <Form.Button type="submit" text={buttons.ok.label} primary /> : null}
        </Modal.Footer>
      </Form>
    </Modal>,
    holder
  )
  return promise
}

export const showShareModal = ({ title, content, buttons = {}, size = 'sm', legalUrl }) => {
  const modal = buildModal(buttons, content)
  buttons = modal.buttons
  content = modal.content
  const promise = modal.promise
  const holder = modal.holder
  const onCloseHandler = modal.onCloseHandler
  const onSubmitHandler = modal.onSubmitHandler

  ReactDOM.render(
    <Modal size={size} title={title} hasCloseButton={true} open onClose={onCloseHandler}>
      <Modal.Body>
        <div className="input-modal">
          <Form method="POST" onSubmit={onSubmitHandler} noAction>
            {content}
            {buttons.ok ? (
              <div className="text-center">
                <Form.Button className="btn btn--small mx-auto" type="submit" text={buttons.ok.label} primary />
              </div>
            ) : null}
            {legalUrl ? (
              <a
                href={legalUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="link--dynamic link__text--gray text-center mt-1"
              >
                <span className="link__text">
                  <span>Hinweise zum Datenschutz</span>
                </span>
              </a>
            ) : null}
          </Form>
        </div>
      </Modal.Body>
    </Modal>,
    holder
  )
  return promise
}

export const showPrompt = (content, { pattern, placeholder, ...options }) => {
  return showModal({
    ...options,
    content: (
      <>
        {content}
        <Form.Input className="mt-2" pattern={pattern} name="value" placeholder={placeholder} required />
      </>
    )
  })
}

export const showPromptCustomized = (content, { ...options }) => {
  return showShareModal({
    ...options,
    content: <>{content}</>
  })
}
export const showConfirm = (content, options) => showModal({ ...options, content })
